import Load from 'components/Load';
import { createNavigationalRoute } from 'modules/app/components/NavigationalLayout';
import { RouteDescriptor, createRouteHandle } from 'routing/types';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';

const AsyncManageBooking = Load(
  () =>
    import(
      /* webpackChunkName: "manage-booking" */ './containers/ManageBookingContainer'
    ),
);

export const manageBookingRoute: RouteDescriptor = {
  id: 'manage-booking.detail',
  path: `${basePath}/manage-booking/:bookingId/*`,
  label: 'Manage Booking',
  audience: 'both',
  layout: 'navigational',
  module: 'manage-booking',
};

export const manageBookingRoutes = [
  createNavigationalRoute({
    key: manageBookingRoute.id,
    id: manageBookingRoute.id,
    hideFooter: true,
    component: AsyncManageBooking,
    path: manageBookingRoute.path,
    noNavbar: isCordova(),
    handle: createRouteHandle(manageBookingRoute),
  }),
];

export const manageBookingRouteDescriptors = [manageBookingRoute];

export default manageBookingRoutes;
